import { Component } from 'react';

import CreditCardForm from 'profile/creditCard/components/CreditCardForm';

import CreditCardPicker from './CreditCardPicker';

class CreditCardLoggedIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCreditCardId: props.selectedCreditCardId
    };
  }

  handleCreditCardChange = (e) => {
    const creditCardId = e.target.value;
    if (creditCardId.length > 0) {
      this.setState({ selectedCreditCardId: creditCardId });
    } else {
      this.setState({ selectedCreditCardId: null });
    }
  };

  render() {
    const { customerCreditCards, handleSaveCreditCard, isSaveCreditCard } =
      this.props;
    const { selectedCreditCardId } = this.state;
    return (
      <>
        <CreditCardPicker
          customerCreditCards={customerCreditCards.data}
          onCreditCardChange={this.handleCreditCardChange}
        />
        {renderCreditCardForm(
          selectedCreditCardId,
          handleSaveCreditCard,
          isSaveCreditCard
        )}
      </>
    );
  }
}

const renderCreditCardForm = (
  selectedCreditCardId,
  handleSaveCreditCard,
  isSaveCreditCard
) => {
  if (selectedCreditCardId) {
    return null;
  }
  return (
    <>
      <CreditCardForm />
      <div>
        <label htmlFor="saveCreditCard">
          <input
            type="checkbox"
            name="saveCreditCard"
            onChange={handleSaveCreditCard}
            value
            checked={isSaveCreditCard}
          />
          Save this information
        </label>
      </div>
    </>
  );
};

export default CreditCardLoggedIn;
